// Why did I create this file you might ask yourself, right?
// This was done in order to avoid a dependency cyle between NorthPanes, SouthPanes, LayoutActions, LayoutSelectors, SelectionSelectors

export const FILTER_PANE_NAME = "Filter";

export type PaneName = typeof FILTER_PANE_NAME;
